import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { InlineSelect, MenuItem } from 'seagull';
import { getClientReminderDays, getVendorReminderDays } from '~/business-logic/notificationSettings';
import { useLocaleKeys } from '~/i18n';
import { daysToMinutes, isDays, minutesToDays, Tab } from '../../../NotificationSettings.utils';
import { GetCadenceDaysDropdownTID } from './CadenceDaysDropdown.testIds';
export const CadenceDaysDropdown = (param)=>{
    let { selectedTab, minutes, onChange } = param;
    var _dayOptions_;
    const { CadenceDaysDropdownTestIds: testIds } = useMemo(()=>GetCadenceDaysDropdownTID(), []);
    const { t: commonTexts } = useLocaleKeys('common');
    const dayOptions = selectedTab === Tab.Vendor ? getVendorReminderDays() : getClientReminderDays();
    const fallbackMinutes = daysToMinutes((_dayOptions_ = dayOptions[0]) !== null && _dayOptions_ !== void 0 ? _dayOptions_ : 1);
    const value = minutes !== null && minutes !== void 0 ? minutes : fallbackMinutes;
    const triggerLabel = minutes != null && !isDays(minutes) ? commonTexts.units.minutesCount({
        count: minutes
    }) : commonTexts.units.daysCount({
        count: minutesToDays(value)
    });
    return /*#__PURE__*/ _jsx(InlineSelect, {
        skin: "primary",
        value: String(value),
        onChange: (event)=>onChange(Number(event.target.value)),
        SelectProps: {
            renderValue: ()=>triggerLabel
        },
        bi: {
            name: 'cadence_days'
        },
        testId: testIds.Trigger(),
        children: dayOptions.map((days)=>/*#__PURE__*/ _jsx(MenuItem, {
                value: String(daysToMinutes(days)),
                testId: testIds.Option(days),
                children: commonTexts.units.daysCount({
                    count: days
                })
            }, days))
    });
};
